export default "__VITE_ASSET__d3d303e4__"